
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { A } from "@solidjs/router";
import { useCalendarState } from "@state/events/calendar-state";
import { useRecordings } from "@state/recordings/state";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import { For, Show } from "solid-js";
import { useService } from "solid-services";
import { css } from "styled-system/css";
import { Flex, Grid } from "styled-system/jsx";

dayjs.extend(relativeTime)

export default function () {
  const { latestRecordingsQuery } = useService(useRecordings)();

  return (
    <Grid gap={0}>
      <For each={latestRecordingsQuery.data ?? []}>
        {(recording, index) => (
          <Flex justifyContent='space-between' alignContent='center' p={3} class={css({
            '& + &': {
              borderTop: 'solid 1px',
              borderColor: 'bg.subtle'
            }
          })}>

            <Flex justifyContent='space-between' alignItems='center' gap={1}>
              <Text fontSize='sm'>{recording.group}</Text>
            </Flex>
            <Flex justifyContent='space-between' alignItems='center' gap={1}>
              <A href={`/recordings/${recording.id}`}>
                <Button variant="outline" size="2xs">
                  Watch
                </Button>
              </A>
            </Flex>
          </Flex>
        )}
      </For>
    </Grid>
  )
}
